import { render, staticRenderFns } from "./ventaDetail.vue?vue&type=template&id=e1e07684"
import script from "./ventaDetail.vue?vue&type=script&lang=js"
export * from "./ventaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports